export default __webpack_public_path__ + "static/media/f2.589d1dc6.svg";